import React from 'react';
import { Button } from 'react-bootstrap';

const CustomButton = ({
  variant = 'contained',
  color = 'primary',
  text,
  onClick,
  type = 'button',
  disabled = false,
  className = '',
  style = {},
  iconLeft = null
}) => {
  const getBootstrapVariant = () => {
    if (['contained', 'contained2', 'contained3', 'contained4'].includes(variant)) return color;
    if (['outline', 'outline2', 'outline3'].includes(variant)) return `outline-${color}`;
    return color;
  };

  return (
    <Button
      variant={getBootstrapVariant()}
      onClick={onClick}
      type={type}
      disabled={disabled}
      className={`common-btn ${variant}-btn ${className}`}
      style={style}
    >
      {/* {text} */}
      <div className="d-flex align-items-center justify-content-center gap-2">
        {iconLeft}
        {text}
      </div>
    </Button>
  );
};

export default CustomButton;
